import { mapGetters, mapActions } from "vuex";
import VueApexCharts from "vue-apexcharts";
import {
  GET_PROVINCE,
  GET_CITY,
  GET_DISTRICT,
  GET_SUB_DISTRICT,
} from "../../../../../../store/modules/location.module";
import {
  GET_TRANSMITTER_COVERAGE,
  SET_BROADCASTING_SERVICE_COVERAGE,
} from "../../../../../../store/modules/tv.module";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    selectedProvince: 0,
    selectedCity: 0,
    selectedDistrict: 0,
    selectedScope: "",
    searchProvince: "",
    searchCity: "",
    searchDistrict: "",
    pagination: {
      page: 1,
      limit: 10,
      totalItems: 0,
      rowsPerPageItems: [10, 20, 30, 40, 500],
    },
    organizerTransmittercategories: [],
    organizerTransmitterSeries: [],
    broadcastingServiceCoverageChartTitle: "",
    broadcastingServiceCoveragePercentageChartTitle: "",
    chartOptions: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 5,
        },
      },
      colors: ["#CB4F4F", "#EA8426", "#CB1F4F", "#CB411F", "#F4F", "#F11"],
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      fill: {
        opacity: 1,
      },
      title: {
        text: "",
        align: "center",
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          fontFamily: undefined,
          color: "#263238",
        },
      },
    },
    headers: [
      {
        text: "NAMOBJ",
        value: "namobj",
      },
      {
        text: "LUASWH",
        value: "luaswh",
      },
      {
        text: "KODE83552",
        value: "kode83552",
      },
      {
        text: "NMOBJE",
        value: "nmobje",
      },
      {
        text: "XKDCPUM2",
        value: "xkdcpum2",
      },
      {
        text: "XKDPKAB2",
        value: "xkdpkab2",
      },
      {
        text: "NKEC",
        value: "nkec",
      },
      {
        text: "NKAB",
        value: "nkab",
      },

      {
        text: "NPROV",
        value: "nprov",
      },
      {
        text: "Shape Lenght",
        value: "shape_lenght",
      },
      {
        text: "TX NAME",
        value: "tx_name",
      },
      {
        text: "AREA OF SE",
        value: "area_of_se",
      },
      {
        text: "PENYELENGGARA",
        value: "penyelenggara",
      },
    ],
  }),
  computed: {
    ...mapGetters([
      "item_province",
      "item_city",
      "item_district",
      "transmitterCoverage",
      "paginationTransmitterCoverage",
      "dateUpdateTransmitterCoverage",
      "broadcastingServiceCoverage",
    ]),
    broadcastingServiceCoverageChartOptions: function () {
      return {
        ...this.chartOptions,
        xaxis: {
          categories: this.broadcastingServiceCoverage.categories || [],
        },
        title: {
          ...this.chartOptions.title,
          text: `Cakupan Layanan Penyiaran ${this.broadcastingServiceCoverageChartTitle}`,
        },
      };
    },
    broadcastingServiceCoveragePercentageChartOptions: function () {
        return {
          ...this.chartOptions,
          xaxis: {
            categories: [],
          },
          title: {
            ...this.chartOptions.title,
            text: `Persentase Cakupan Layanan Penyiaran ${this.broadcastingServiceCoveragePercentageChartTitle}`,
          },
        };
      },
  },
  methods: {
    ...mapActions([
      GET_PROVINCE,
      GET_CITY,
      GET_DISTRICT,
      GET_SUB_DISTRICT,
      GET_TRANSMITTER_COVERAGE,
      SET_BROADCASTING_SERVICE_COVERAGE,
    ]),
    initialize() {
      this[GET_PROVINCE]();
      this.handleGetTransmitterCoverageData();
      this.handleGetBroadcastingServiceCoverage();
    },
    handleGetTransmitterCoverageData() {
      const { page, limit } = this.pagination;
      const params = {
        page,
        limit,
        ...(this.selectedProvince
          ? {
              province: this.item_province.find(
                (item) => item.id == this.selectedProvince
              ).name,
            }
          : {}),
        ...(this.selectedCity
          ? {
              city: this.item_city.find((item) => item.id == this.selectedCity)
                .name,
            }
          : {}),
        ...(this.selectedDistrict
          ? {
              district: this.item_district.find(
                (item) => item.id == this.selectedDistrict
              ).name,
            }
          : {}),
      };
      this[GET_TRANSMITTER_COVERAGE](params);
    },
    handleGetBroadcastingServiceCoverage() {
      const params = {
        ...(this.selectedProvince
          ? {
              province: this.item_province.find(
                (item) => item.id == this.selectedProvince
              ).name,
            }
          : {}),
        ...(this.selectedCity
          ? {
              city: this.item_city.find((item) => item.id == this.selectedCity)
                .name,
            }
          : {}),
      };
      this[SET_BROADCASTING_SERVICE_COVERAGE](params);
      if (this.selectedCity) {
        this.broadcastingServiceCoverageChartTitle = `${
          this.item_city.find((item) => item.id == this.selectedCity).name
        }, ${(this.broadcastingServiceCoverageChartTitle = this.item_province.find(
          (item) => item.id == this.selectedProvince
        ).name)}`;
      } else if (this.selectedProvince) {
        this.broadcastingServiceCoverageChartTitle = this.item_province.find(
          (item) => item.id == this.selectedProvince
        ).name;
      } else {
        this.broadcastingServiceCoverageChartTitle = "";
      }
    },
    selectCity() {
      if (this.selectedProvince == 0) {
        this[GET_CITY](this.selectedProvince);
      } else {
        this.selectedCity = 0;
        this.selectedDistrict = 0;
        this.selectedSubDistrict = 0;
        this[GET_CITY](this.selectedProvince);
      }
    },
    selectDistrict() {
      this[GET_DISTRICT](this.selectedCity);
    },
    changeLimitPagination(val) {
      this.pagination = {
        ...this.pagination,
        page: 1,
        limit: val,
      };
    },
    handleApply() {
      this.handleGetTransmitterCoverage();
      this.handleGetBroadcastingServiceCoverage();
    },
    handleReset() {
      this.resetDataChart();
      this.resetDataTable();
    },
    resetDataChart() {
      this.selectedProvince = 0;
      this.selectedCity = 0;
      this.handleGetBroadcastingServiceCoverage();
    },
    resetDataTable() {
      this.selectedProvince = 0;
      this.selectedCity = 0;
      this.selectedDistrict = 0;
      this.pagination = {
        ...this.pagination,
        page: 1,
        limit: 10,
      };
    },
  },
  watch: {
    pagination: {
      handler() {
        this.handleGetTransmitterCoverageData();
      },
      deep: true,
    },
  },
  mounted() {
    this.initialize();
  },
};
